function snakeToCamelKey(key: string): string {
  return key.replace(/_([a-z])/g, (_, letter: string) => letter.toUpperCase());
}

/**
 * Recursively rewrites object keys from snake_case to camelCase so Zod schemas
 * match Pacific.Agentic.Api JSON when aliases are not serialized.
 */
export function normalizeCoreApiJson<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeCoreApiJson(item)) as T;
  }
  if (value !== null && typeof value === "object") {
    const record = value as Record<string, unknown>;
    const normalized: Record<string, unknown> = {};
    for (const [key, child] of Object.entries(record)) {
      normalized[snakeToCamelKey(key)] = normalizeCoreApiJson(child);
    }
    return normalized as T;
  }
  return value;
}
